import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {throwError} from 'rxjs';

import {LogInComponent} from './login.component';

import {RoutesService} from '../Routes/routes.service';

import {Login} from 'app/core-ui/abstract/login/Login';
import {MenuService} from 'app/core-ui/abstract/menu/menu.service';
import {ConfigService} from 'app/core-ui/abstract/services/config.service';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {VisualsService} from 'app/core-ui/abstract/services/visuals.service';
import {HomeService} from '../../Menus/Home/home.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'sso-login',
  templateUrl: 'sso.component.html',
  providers: [MenuService, RoutesService, HomeService],
})
export class SingleSignOnComponent extends LogInComponent {
  token = '';

  constructor(
    public router: Router,
    public menusService: MenuService,
    public routesService: RoutesService,
    public securityService: SecurityService,
    public logger: LogService,
    public visualsService: VisualsService,
    public configService: ConfigService,
    public homeService: HomeService,
    public eventsEmitterService: EventsEmitterService,
    public route: ActivatedRoute,
  ) {
    super(
      router,
      menusService,
      routesService,
      securityService,
      logger,
      visualsService,
      configService,
      homeService,
      eventsEmitterService,
      route,
    );

    this.securityService.clearStorages();
    localStorage.setItem(
      'langId',
      this.configService.getLangDefault() ? this.configService.getLangDefault().toString() : '2',
    );
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe({
      next: (params) => {
        this.logger.log(params);
        // Defaults to null if no query param provided.
        // (+) converts string 'id' to a number
        this.token = params['token'];

        if (this.token != null && this.token != '') {
          this.doLogin(new Login('password', 'sso_' + this.token, 'password'));
        } else {
          this.loading = false;
          this.loginerror = true;
          this.loginmsg = 'No token provided!';
        }
      },
    });
  }

  public goHome() {
    //not all broswers support "window.location.origin"
    if (!window.location.origin) {
      window.location.href =
        window.location.protocol +
        '//' +
        window.location.hostname +
        (window.location.port ? ':' + window.location.port : '');
    } else {
      window.location.href = window.location.origin;
    }
  }

  public doLogin(login: Login) {
    this.loading = true;
    this.loginerror = false;
    this.securityService.sendTokenRequest(login).subscribe({
      next: (data) => {
        this.logger.log(data);
        if (data) {
          this.securityService.saveToStorage('access_token', data.access_token);
          this.securityService.saveToStorage('refresh_token', data.refresh_token);
          this.securityService.getAuthorities().subscribe({
            next: (data) => {
              let roles: any[] = data;
              this.securityService.setUserRoles(roles);

              Promise.all(this.saveVisualsToStorage()).then(
                (success) => {
                  //this.loading = false;
                  this.routesService.getRoutes('menu/home');
                },
                (error) => {
                  this.loading = false;
                  this.loginerror = true;
                  this.loginmsg = 'Error. Please try again.';
                },
              );
            },
            error: (error) => {
              this.loading = false;
              this.loginerror = true;
              this.loginmsg = 'Error. Please try again.';
            },
          });

          return true;
        } else {
          this.loading = false;
          this.loginmsg = 'Wrong Username or Password. Please, try again!';
        }
      },
      error: (error) => {
        this.loading = false;
        this.loginerror = true;
        this.loginmsg = error;

        if (error.toString().indexOf('sso') > 0) {
          this.securityService.goToLogin('sso', 'true');
        }

        this.logger.error('Login error!');
        return throwError(() => new Error(error));
      },
    });
  }
}
